import React, { useEffect, useState } from 'react'
import { gql, GraphQLClient } from 'graphql-request'
import styled from 'styled-components'
import { Box, Button, Link, IconButton, Typography } from '@mui/material'
import Marquee from 'react-fast-marquee'
import axios from 'axios'

const Info = styled.div`
  background: #84FF70;
  padding: 20px 0px;
  margin-top: -7px;
`
const Menu = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 20px 20px;
  max-width: 1310px;
  width: 100%;
  margin-left: 3%;
  margin:0 auto;
`
const Wrapper = styled.div`
  width:100%;
`
const Content = styled.div`
  margin: 0 auto;
  height: fit-content;
  max-width: 1088px;
  width: 90%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Title = styled.div`
  font-size: 96px;
  font-weight: 700;
  line-height: 104px;
  text-transform: uppercase;
  color: white;
  margin-top: 210px;

  @media (max-width: 705px) {
    font-size: 46px;
    line-height: 52px;
  }
`
const Video = styled.video`
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
`
const MButton = styled(Button)`
  padding: 16px 48px !important;
  border-radius: 28px !important;
  max-width: 403px !important;
  width: 100% !important;
`
const StyledLink = styled(Link)`
  font-family: 'Poppins' !important;
  font-size: 18px !important;
  font-weight: 800 !important;
  color: #7381FC !important;
  text-decoration: none !important;
  @media (max-width: 705px) {
    display: none;
  }
`
const StyledButtonLink = styled(Link)`
  text-decoration: none !important;
  color: white !important;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover{
    text-decoration: none;
  }
`
const Icon = styled.img`
  width:18px;
  height:18px;
  margin-left:4px;
`
const Typo = styled.div`
  letter-spacing: 2px;
  font-size:20px;
  font-family: Poppins;
  font-weight: 300;
  cursor: pointer:
  color: #0C0720;
`

const Image = styled.img`
`
// type coin = {
//   name: string
// }
interface Props {
  isburger: boolean,
  SetIsBurger: React.Dispatch<React.SetStateAction<boolean>>;
}
const Header = (props: Props) => {
  const [binance, setBinance] = useState<any>()
  const [bitcoin, setBitcoin] = useState<any>()
  const [ethereum, setEthereum] = useState<any>()
  const [robust, setRobust] = useState<any>()
  const [rbs, setRbs] = useState<any>()

  const fetchQuery = async () => {
    const query = gql`
      {
        ethereum(network: bsc) {
          dexTrades(
            options: {desc: ["block.height","tradeIndex"], limit: 1}
            exchangeName: {in: ["Pancake", "Pancake v2"]}
            baseCurrency: {is: "0x95336aC5f7E840e7716781313e1607F7C9D6BE25"}
            quoteCurrency: {is: "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"}
            date: {after: "2022-01-02"}
          ) {
            transaction {
              hash
            }
            tradeIndex
            smartContract {
              address {
                address
              }
              contractType
              currency {
                name
              }
            }
            tradeIndex
            block {
              height
            }
            baseCurrency {
              symbol
              address
            }
            quoteCurrency {
              symbol
              address
            }
            quotePrice
        
          }
        }
      }
    `
    const client = new GraphQLClient(
      "https://graphql.bitquery.io",
      {
        headers: {
          "content-type": "application/json",
          "X-API-KEY": "BQYMant9JlmMNO36X2W3IO6CpjHFlOv4"
        }
      }
    )
    const res = await client.request(query)
    setRbs(Number(res.ethereum.dexTrades[0].quotePrice))
  }

  useEffect(() => {
    axios.get("https://api.coingecko.com/api/v3/simple/price?ids=robust-token%2Cbinancecoin%2Cbitcoin%2Cethereum&vs_currencies=usd")
      .then((res: any) => {
        setBinance(res.data["binancecoin"])
        setBitcoin(res.data["bitcoin"])
        setEthereum(res.data["ethereum"])
        setRobust(res.data["robust-token"])
      })
    fetchQuery()
  }, [])

  const title = "Extremely limited supply, rigid deflationary mechanism"
  const subTitle = "Robust Token is an original concept token on the Binance Smart Chain with a limited supply of 100 000 RBT and a 1% burn per transaction that gets converted into Robust Reward (RBW)."

  const handle = () => {
    props.SetIsBurger(!props.isburger);
  }

  return (
    <>
      <Wrapper style={{ backgroundColor: '#5F47EE' }} >
        <Menu style={!props.isburger ? {} : { position: 'unset', background: '#5F47EE' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {!props.isburger ? <Image src="assets/svg/logoHD.svg" alt="logoHD" /> : <Image src="assets/svg/logo.png" alt="logoHD" />}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <StyledLink href='https://bscscan.com/address/0x891e4554227385c5c740f9b483e935e3cbc29f01' target='_blank'>
                {!props.isburger ? <Image src="assets/svg/contract2.png" alt="share" style={{ marginLeft: 11 }} /> : <Image src="assets/svg/contract.png" alt="share" style={{ marginLeft: 11 }} />}
              </StyledLink>
              {!props.isburger ?
                <IconButton sx={{ ml: '55px', padding: '0px', width: '56px', height: '56px' }} onClick={handle}>
                  <Image src="assets/svg/hamburger.svg" alt="logoHD" />
                </IconButton> :
                <IconButton sx={{ ml: '55px', padding: '0px', width: '56px', height: '56px' }} onClick={handle}>
                  <Image src="assets/svg/close.png" alt="logoHD" />
                </IconButton>
              }
            </Box>
          </Box>
        </Menu>
      </Wrapper>
      <Wrapper>
        <Video id="video" autoPlay loop muted preload="none">
          <source src="assets/video/robust.mp4" type="video/mp4" />
        </Video>
        <Content style={{ display: props.isburger ? 'none' : 'block' }}>
          <Title>{title}</Title>
          <Typography variant='h6' color='white' sx={{ mb: '48px' }}>{subTitle}</Typography>
          <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <MButton variant="contained"
              sx={{
                color: 'white',
                fontSize: 18,
                mb: '8px',
                background: '#5F47EE',
                boxShadow: 'none',
                '&:hover': {
                  background: '#5F47EE',
                  boxShadow: 'none'
                }
              }}>
              <StyledButtonLink href='https://exchange.robustswap.com/#/swap?outputCurrency=0x891e4554227385c5c740f9b483e935e3cbc29f01' target='_blank'>
                BUY $RBT
                <Icon src="assets/svg/gointo2.png" style={{ width: '22px', height: '22px' }} />
              </StyledButtonLink>
            </MButton>
            <a
              rel="noreferrer"
              target="_blank"
              style={{ textDecoration: 'none' }}
              href="https://robustprotocol.fi/RobustProtocol.pdf"
            >
              <MButton sx={{ color: 'white', fontSize: 18, mb: '42px' }}>See Whitepaper</MButton>
            </a>
          </div>
        </Content>
        <Info style={{ display: props.isburger ? 'none' : 'block' }}>
          <Marquee gradient={false} loop={10000} pauseOnHover={true}>
            <Typo>
              {`RBT $${robust?.usd} | RBS $${rbs?.toFixed(2)} | BNB $${binance?.usd} | BTC $${bitcoin?.usd} | ETH $${ethereum?.usd}`}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {`RBT $${robust?.usd} | RBS $${rbs?.toFixed(2)} | BNB $${binance?.usd} | BTC $${bitcoin?.usd} | ETH $${ethereum?.usd}`}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </Typo>
          </Marquee>
        </Info>
      </Wrapper>
    </>
  )
}

export default React.memo(Header)

